/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import customStyles from "../../assets/styles/customStyles";
import MainHeader from "../Shared/components/Header";
import HomeImg from "../../assets/images/icon_menus/HomeIcon.json";
import ProductIcon from "../../assets/images/main_dashboard_icons/Product.json";
import PurchaseIcon from "../../assets/images/main_dashboard_icons/Purchase.json";
import AdminIcon from "../../assets/images/main_dashboard_icons/Admin.json";
import SalesIcon from "../../assets/images/main_dashboard_icons/Sales.json";
import DeliveryIcon from "../../assets/images/main_dashboard_icons/Delivery.json";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "../../assets/images/icon_actions/Delete Icon.svg";
import SelctMultiples from "../../assets/images/icon_actions/SelctMultiples.svg";

import clsx from "clsx";
import closeImg from "../../assets/images/icon_menus/Close Button.svg";
import { ListTable } from "./ListTable";
import AccordionDropDownIcon from "../../assets/images/icon_actions/AccordionDropDown.png";
import { NavLink, useParams } from "react-router-dom";
import usePrevious from "../Shared/components/Previous";
import { Row, Col, Image, Space, Modal } from "antd";
import { Typography, Button, TextField } from "@mui/material";
import moment from 'moment';
import actions from "./redux/actions";
import crudActions from "../CRUD/redux/actions";
import setUpActions from "../YounoteAdmin/Setup/redux/actions";
import { AutoCompleteComponent } from "../Shared/components/AutoCompleteComponent";
import { getUserId } from '../../helpers/utilities';
import DeleteModal from "../Shared/components/DeleteModal";
import StarIcon from "../../assets/images/icon_actions/Star.svg";
import StarMessage from "../../assets/images/icon_actions/StarMessage.svg";
import infoMarkIcon from "../../assets/images/icon_actions/infoMark.svg";
import { LottieAnimationHover } from "../Shared/components/LottieAnimationHover";
import { toast } from 'react-toastify';
import { capitalizeFirstLetter } from "../../helpers/utilities";
import InvoiceModal from "../Shared/components/InvoiceModal";
import PurchaseInvoiceModal from "../Shared/components/PurchaseInvoiceModal";
import QuoteModal from "../Shared/components/QuoteModal";
import OrderModal from "../Shared/components/OrderModal";
import SupplyOrderModal from "../Shared/components/SupplyOrderModal";
import SupplyQuoteModal from "../Shared/components/SupplyQuoteModal";
import ViewIcon from "../../assets/images/icon_actions/View.svg";
import SearchIcon from "../../assets/images/icon_actions/Search Icon.svg";
import { checkModulePermission, idNamingConversion } from '../../helpers/utilities';

const Home = (props) => {
    const { history } = props;
    const { notificationDetails } = useSelector(state => state.commonReducer);
    const { rejectDetails } = useSelector(state => state.younoteAdminSetupReducer);
    const { readDetails } = useSelector(state => state.crudReducer);
    const { editDetails, editError, editLoader, deleteDetails, deleteError, editData } = useSelector(state => state.crudReducer);
    const [toggle, setToggle] = useState(false);
    const [view, setView] = useState(false);
    const [datas, setDatas] = useState({});
    const [deleteType, setDeleteType] = useState('');
    const [type, setType] = useState('all');
    const classes = customStyles();
    const [skip, setSkip] = useState(0);
    const limit = 100;
    const [toastMessage, setToastMessage] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteAllModal, setDeleteAllModal] = useState(false);
    const [selected, setSelected] = useState([]);
    const [multiples, setMultiples] = useState(false);
    const { notificationId } = useParams();
    const prevDeleteDetails = usePrevious(deleteDetails);
    const prevDeleteError = usePrevious(deleteError);
    const purchaseContainer = useRef(null);
    const salesContainer = useRef(null);
    const adminContainer = useRef(null);
    const deliveryContainer = useRef(null);
    const productContainer = useRef(null);
    const purchaseContainerAnim = useRef(null);
    const salesContainerAnim = useRef(null);
    const adminContainerAnim = useRef(null);
    const deliveryContainerAnim = useRef(null);
    const productContainerAnim = useRef(null);
    const [actionType, setActionType] = useState('');
    const [actionData, setActionData] = useState('');
    const [component, setComponent] = useState('');
    const prevReadDetails = usePrevious(readDetails);
    const [open, setOpen] = useState(false);
    const [visible, setVisible] = useState(false);
    const [reasonId, setReasonId] = useState('');
    const [search, setSearch] = useState('');
    const [updateType, setUpdateType] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {
        loadTasks();
        dispatch({ type: setUpActions.REJECT_DETAILS_START });
    }, []);


    const loadTasks = () => {
        let filter = { ["and"]: [{ toUserId: getUserId() }] };
        dispatch({
            type: actions.NOTIFICATION_START,
            url: 'notifications',
            filter: {
                where: filter,
                order: 'id DESC',
            }
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(type);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(type);
                }, 500);
            }
        }
    }, [search]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });
            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);


    useEffect(() => {
        if (notificationId !== '') {
            if (notificationId === 'all') {
                setToggle(true);
                setType('all');
                dispatchFilter('all');
            } else {
                let a = notificationDetails?.length > 0 && notificationDetails?.filter((el) => { return el.id === parseInt(notificationId) });
                if (a && a?.length) {
                    setView(true);
                    setDatas(a[0]);;
                    setToggle(true);
                }
            }
        }
    }, [notificationId]);


    const onDelete = (data) => {
        setDeleteModal(true);
        setDatas(data);
    }

    const customDispatch = (id) => {
        let details = { is_seen: true, is_actionable: true };
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: "notifications",
            title: "Notifications",
            id: id,
            details: details
        });
    }

    const handleRead = (data, type) => {
        let details = '';
        if (type === 'read') {
            details = { is_seen: true, is_actionable: true };
        } else {
            details = { is_seen: false };
        }
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: "notifications",
            title: "Notifications",
            id: data.id,
            details: details
        });
        setToastMessage(true);
        setUpdateType(type);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            if (actionType !== '') {
                let details = { is_seen: true, action_status: actionType };
                dispatch({
                    type: crudActions.EDIT_DETAILS_START,
                    url: "notifications",
                    title: "Notifications",
                    id: actionData.id,
                    details: details
                });
                setActionType('');
                setActionData('');
                toast.dismiss();
                setView(false);
                toast(editData?.status);
                setToastMessage(false);
            } else {
                loadTasks();
                if (reasonId !== '') {
                    handleOk();
                }
                dispatchFilter(type);
                setSelected([]);
                setMultiples(false);
                if (toastMessage) {
                    toast.dismiss();
                    if (updateType === 'unread') {
                        toast('Message Changed to Unread Status Successfully');
                    } else if (updateType === 'Starred' || updateType === 'Un-Starred') {
                        toast('Notification ' + updateType + ' Updated Successfully');
                    } else {
                        toast('Message Changed to Read Status Successfully');
                    }
                }
            }
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [editDetails, editError]);


    const dispatchFilter = (type = 'new', skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [{ toUserId: getUserId() }] };

        if (type === 'unread') {
            filter['and'].push({ is_seen: false });
        } else if (type === 'starred') {
            filter['and'].push({ is_starred: true });
        }
        let or = { ["or"]: [] };
        if (search !== '') {
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ title: { like: '%' + search.trim() + '%' } });
        }
        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'notifications',
            skip: skip,
            filter: {
                where: filter,
                order: 'id DESC',
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(type, s);
    }

    const onView = (data) => {
        setView(true);
        setDatas(data);
        setReasonId('');
        customDispatch(data.id);
        setToastMessage(false);
    }

    const handleClearAll = (type) => {
        setDeleteAllModal(true);
        setDeleteType(type);
    }

    const onDeleteAllPopup = () => {
        let selectedArray = notificationDetails.filter(function (el) { return el.is_starred === false && selected.find(e => e === el.id) });
        let a = selectedArray?.length > 0 ? selectedArray.map((item) => { return item.id }) : [];
        dispatch({
            type: crudActions.DELETE_DETAILS_START,
            url: deleteType === 'all' ? 'notifications/deleteByUserId/' + getUserId() + '/' + type : 'notifications/deleteByIds',
            title: 'Notifications',
            details: deleteType === 'ids' ? a : {}
        });
        setSelected([]);
        setDeleteAllModal(false);
        setDeleteType('');
    }

    const handleMessages = (type) => {
        setToggle(!toggle);
        setType(type);
        setSelected([]);
        setMultiples(false);
        if (!toggle) {
            dispatchFilter(type);
        }
    }

    useEffect(() => {
        if (prevDeleteDetails !== undefined && deleteDetails && prevDeleteDetails !== deleteDetails) {
            // dispatchFilter(type);
            setSelected([]);
            setView(false);
            setDeleteAllModal(false);
            setDeleteType('');
        } else if (prevDeleteError !== undefined && deleteError && prevDeleteError !== deleteError) {

        }
    }, [deleteDetails, deleteError]);

    const handleRowClick = (id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected?.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const previewMessages = () => {
        switch (type) {
            case "new": return `New Messages ${notificationDetails?.length > 0 ? notificationDetails?.filter((el) => { return el.is_seen === false })?.length : 0}`;
            case "unread": return `Unread Messages ${notificationDetails?.length > 0 ? notificationDetails?.filter((el) => { return el.is_seen === false })?.length : 0}`;
            case "starred": return `Starred Messages ${notificationDetails?.length > 0 ? notificationDetails?.filter((el) => { return el.is_starred === true })?.length : 0}`;
            case "all": return `Notification Messages ${notificationDetails?.length || 0}`;
            default: return `Notification Messages ${notificationDetails?.length || 0}`;
        }
    }

    const handleClose = () => {
        commonClose();
    }

    const commonClose = () => {
        setType('all');
        setSelected([]);
        setMultiples(false);
        setView(false)
    }

    const onStarred = (data) => {
        let details = { is_seen: true, is_actionable: true, is_starred: !data.is_starred };
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: "notifications",
            titleFull: !data.is_starred ? 'Selected message is Star Marked successfully' : 'Selected message is Un-Starred Sucessfully',
            id: data.id,
            details: details
        });
        setUpdateType(data.is_starred ? 'Un-Starred' : 'Starred');
        datas.is_starred = !data.is_starred;
        setDatas({
            ...datas
        });
        setToastMessage(true);
    }

    const handleAccept = (data, type) => {
        let details = { toId: data?.fromId, profileId: data?.profileId };
        let url = '';
        if (data.title === 'Customer-add - PY001') {
            url = 'tobecustomer';
            details.status = type === 'accept' ? true : false;
        } else if (data.title === 'Supplier-add - PY005') {
            url = 'tobesupplier';
            details.status = type === 'accept' ? true : false;
        } else if (data.title === 'Cust-Self Bill-Add - PY009') {
            url = 'acceptsalesbill';
            details.status = type;
        } else if (data.title === 'Supply-Self Bill-Add - PY012') {
            url = 'acceptpurchasebill';
            details.status = type;
        } else if (data.title === 'Sales Quote-Add - PY031'
            || data.title === 'Sales Quote Reject-Re-Submitted - PY038'
            || data.title === 'Supply Quote Request-Re-Submitted - PY036') {
            url = 'acceptsalesquote';
            delete details.profileId;
            details.status = type === 'accept' ? type : 'reject';
            details.quoteId = data?.profileId;
        } else if (data.title === 'Supply Quote Request-Add - PY034' ||
            data.title === 'Sales Quote Reject-Re-Submitted - PY038' ||
            data.title === 'Supply Quote Reject-Re-Submitted - PY040') {
            url = 'acceptsupplyquote';
            delete details.profileId;
            details.status = type === 'accept' ? type : 'reject';
            details.quoteId = data?.profileId;
        } else if (data.title === 'Sales Order-Add - PY040' ||
            data.title === 'Sales Order Reject-Re-Submitted - PY047'
        ) {
            url = 'v1/sales-order/acceptsalesorder';
            delete details.profileId;
            details.status = type === 'accept' ? type : 'reject';
            details.orderId = data?.stringId;
        } else if (data.title === 'Supply Order Request-Add - PY043' ||
            data.title === 'Supply Order Request-Re-Submitted - PY045'
        ) {
            url = 'v1/sales-order/acceptpurchaseorder';
            delete details.profileId;
            details.status = type === 'accept' ? type : 'reject';
            details.orderId = data?.stringId;
        }
        if (type === 'reject') {
            details.reasonId = reasonId;
        }
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: url,
            title: "Notifications",
            method: "put",
            details: details
        });
        setActionData(data);
        setActionType(type === 'cusReject' ? 'reject' : type);
        setToastMessage(true);
    }

    const handleViewDocument = (data) => {
        let url = '';
        let c = '';
        if (data.title === 'Cust-Self Bill-Add - PY009') {
            url = 'selfBill';
            c = 'customer';
        } else if (data.title === 'Supply-Self Bill-Add - PY012') {
            url = 'purchaseSelfBill';
            c = 'supplier';
        } else if (data.title === 'Supply Quote Request-Add - PY034') {
            url = 'supply-quotes';
            c = 'supplyQuote';
        } else if (data.title === 'Sales Order-Add - PY040' ||
            data.title === 'Sales Order Reject-Re-Submitted - PY047') {
            url = 'v1/sales-order/sales-orders';
            c = 'salesOrder';
        } else if (data.title === 'Supply Order Request-Add - PY043' ||
            data.title === 'Supply Order Request-Re-Submitted - PY045'
        ) {
            url = 'v1/sales-order/purchase-orders';
            c = 'purchaseOrder';
        } else {
            url = 'sales-quotes';
            c = 'salesQuote';
        }
        setComponent(c);
        dispatch({
            type: crudActions.READ_DETAILS_START,
            id: data?.profileId || data?.stringId,
            //  url: data.title === 'Cust-Self Bill-Add - PY009' ? "selfBill" : "purchaseSelfBill"
            url: url
        });
    }


    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            // let c = 'customer';
            // if (readDetails?.supplierId) {
            //     c = 'supplier'
            // } else if (readDetails?.supplierId) {
            //     c = 'quote'
            // }
            // setComponent(readDetails?.supplierId ? 'supplier' : 'customer');
            setOpen(true);
        }
    }, [readDetails]);

    const handleOk = () => {
        setVisible(false);
        setReasonId('');
    };

    const handleReject = (datas) => {
        setDatas(datas);
        setVisible(true);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }


    return (
        <React.Fragment>
            <MainHeader  {...props} notificationClick={(data) => handleMessages(data)} title={'Home'} img={HomeImg} links={[]} close={false} />
            <div className={clsx(classes.listTableMargin, classes.containerBorder, classes.containerBorderFlex, classes.notificationOverflow)}>
                {/* <ClickAwayListener onClickAway={() => handleClickAway()}> */}
                <div className={clsx(classes.parenAccordion, { [classes.toggleOpen]: toggle })}>
                    <div className={clsx(classes.accordionHead, classes.notificationTable, { [classes.multiples]: multiples })}>
                        {
                            view ?
                                <>
                                    <Row className={clsx(classes.bold, classes.bgwhite, classes.toggleRow)}>
                                        <Col className={clsx(classes.textAlignRight, classes.color, classes.opacityNone)} span={24}>
                                            <NavLink to={'#'} className={classes.notificationCloseIcon} onClick={() => handleClose()}>
                                                <Image src={closeImg} preview={false} className={classes.cursor} />
                                            </NavLink>
                                        </Col>
                                        <Col span={24}>
                                            <Row className={clsx(classes.margin10t, classes.borderBottom)}>
                                                <Col xs={24} sm={20} md={20} lg={20} xl={20} xxl={20}>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize13, classes.disInline)}>{moment(datas?.createTs).format('DD MMM YYYY / HH.mm')}</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.disInline, classes.marginLeft20)}>Message Type</Typography>
                                                    <Typography variant={'h6'} style={{ marginLeft: 10 }} className={clsx(classes.textFieldColor, classes.fonSize13, classes.disInline)}>{datas?.title}</Typography>
                                                </Col>
                                                <Col xs={24} sm={4} md={4} lg={4} xl={4} xxl={4} className={classes.textAlignRight}>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        <NavLink to={'#'} id={idNamingConversion('Delete', 'notification', 'Link')} className={clsx({ [classes.disabled]: datas?.is_starred })} onClick={() => onDelete(datas)}>
                                                            <Image src={DeleteIcon} preview={false} />
                                                        </NavLink>
                                                        <NavLink to={'#'} id={idNamingConversion('Stared', 'notification', 'Link')} onClick={() => onStarred(datas)}>
                                                            <Image src={datas?.is_starred ? StarMessage : StarIcon} preview={false} />
                                                        </NavLink>
                                                    </Space>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={18}>
                                            <Typography variant={'h6'}
                                                className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.disInline, classes.margin20t)}>
                                                Message {datas?.action_status !== null ? `- ${capitalizeFirstLetter(datas?.action_status)}` : ''}
                                            </Typography>
                                        </Col>
                                        {
                                            datas?.is_actionable && (datas?.title === 'Cust-Self Bill-Add - PY009' ||
                                                datas?.title === 'Supply-Self Bill-Add - PY012') && <Col span={6} className={classes.textAlignRight}>
                                                <NavLink to="#" id={idNamingConversion('View Document', 'notification', 'Link')} onClick={() => handleViewDocument(datas)} className={clsx(classes.margin20t, classes.customLink)}>
                                                    <Image src={ViewIcon} preview={false} /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>View Document</span>
                                                </NavLink>
                                            </Col>
                                        }
                                        {
                                            datas?.is_actionable && (
                                                datas?.title === 'Sales Quote Reject-Re-Submitted - PY038' ||
                                                datas?.title === 'Sales Quote-Add - PY031' ||
                                                datas?.title === 'Supply Quote Request-Add - PY034' ||
                                                datas?.title === 'Supply Quote Request-Re-Submitted - PY036' ||
                                                datas?.title === 'Supply Quote Reject-Re-Submitted - PY040') && <Col span={6} className={classes.textAlignRight}>
                                                <NavLink to="#" id={idNamingConversion('View Quote', 'notification', 'Link')} onClick={() => handleViewDocument(datas)} className={clsx(classes.margin20t, classes.customLink)}>
                                                    <Image src={ViewIcon} preview={false} /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>View Quote</span>
                                                </NavLink>
                                            </Col>
                                        }
                                        {
                                            datas?.is_actionable && (
                                                datas?.title === 'Sales Order-Add - PY040' ||
                                                datas?.title === 'Sales Order Reject-Re-Submitted - PY047' ||
                                                datas?.title === 'Supply Order Request-Add - PY043' ||
                                                datas?.title === 'Supply Order Request-Re-Submitted - PY045'
                                            ) && <Col span={6} className={classes.textAlignRight}>
                                                <NavLink to="#" id={idNamingConversion('View Order', 'notification', 'Link')} onClick={() => handleViewDocument(datas)} className={clsx(classes.margin20t, classes.customLink)}>
                                                    <Image src={ViewIcon} preview={false} /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>View Order</span>
                                                </NavLink>
                                            </Col>
                                        }
                                        <Col span={24}>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize13, classes.disInline, classes.margin20t)}>{datas?.description}</Typography>
                                        </Col>
                                        <Col span={24} className={clsx(classes.margin20t, classes.textAlignRight)}>
                                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                                {
                                                    datas?.is_actionable && (datas?.action_status === 'requested') &&
                                                    <>
                                                        {
                                                            (datas?.title === 'Cust-Self Bill-Add - PY009' ||
                                                                datas?.title === 'Sales Quote-Add - PY031' ||
                                                                datas?.title === 'Customer-add - PY001' ||
                                                                datas?.title === 'Supplier-add - PY005' ||
                                                                datas?.title === 'Sales Quote Reject-Re-Submitted - PY038' ||
                                                                datas?.title === 'Supply Quote Request-Add - PY034' ||
                                                                datas?.title === 'Supply Quote Request-Re-Submitted - PY036' ||
                                                                datas?.title === 'Sales Order-Add - PY040' ||
                                                                datas?.title === 'Sales Order Reject-Re-Submitted - PY047' ||
                                                                datas?.title === 'Supply Order Request-Add - PY043' ||
                                                                datas?.title === 'Supply Order Request-Re-Submitted - PY045' ||
                                                                datas?.title === 'Supply Quote Reject-Re-Submitted - PY040') &&
                                                            <Button
                                                                key="Accept"
                                                                color="primary"
                                                                variant="contained" id={idNamingConversion('Accept', 'notification', 'Button')}
                                                                onClick={() => handleAccept(datas, 'accept')}
                                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                                                            >Accept</Button>
                                                        }
                                                        {
                                                            (datas?.title === 'Cust-Self Bill-Add - PY009' || datas?.title === 'Supply-Self Bill-Add - PY012') && <Button
                                                                key="Accept & Confirm"
                                                                color="primary"
                                                                variant="contained"
                                                                id={idNamingConversion('Accept & Confirm', 'notification', 'Button')}
                                                                onClick={() => handleAccept(datas, 'accept&confirm')}
                                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                                                            >Accept & Confirm</Button>
                                                        }
                                                        {
                                                            (datas?.title === 'Cust-Self Bill-Add - PY009' ||
                                                                datas?.title === 'Supply-Self Bill-Add - PY012') &&
                                                            <Button
                                                                key="Reject"
                                                                color="primary"
                                                                variant="contained"
                                                                id={idNamingConversion('Reject', 'notification', 'Button')}
                                                                onClick={() => handleReject(datas)}
                                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: editLoader })}
                                                            >Reject</Button>
                                                        }
                                                        {
                                                            (datas?.title === 'Customer-add - PY001' ||
                                                                datas?.title === 'Supplier-add - PY005' ||
                                                                datas?.title === 'Sales Quote-Add - PY031' ||
                                                                datas?.title === 'Sales Quote Reject-Re-Submitted - PY038' ||
                                                                datas?.title === 'Supply Quote Request-Add - PY034' ||
                                                                datas?.title === 'Supply Quote Request-Re-Submitted - PY036' ||
                                                                datas?.title === 'Sales Order-Add - PY040' ||
                                                                datas?.title === 'Sales Order Reject-Re-Submitted - PY047' ||
                                                                datas?.title === 'Supply Order Request-Add - PY043' ||
                                                                datas?.title === 'Supply Order Request-Re-Submitted - PY045' ||
                                                                datas?.title === 'Supply Quote Reject-Re-Submitted - PY040') &&
                                                            <Button
                                                                key="save"
                                                                color="primary"
                                                                variant="contained"
                                                                id={idNamingConversion('Reject', 'notification', 'Button')}
                                                                onClick={() => handleAccept(datas, 'cusReject')}
                                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: editLoader })}
                                                            >Reject</Button>
                                                        }
                                                    </>
                                                }
                                                {
                                                    datas?.title === 'New Batch - PY017' && <NavLink id={idNamingConversion('Inbound Price List', 'notification', 'Link')} to="/admin/batch-process/price-list/inbound"
                                                        className={clsx(classes.modalBtn)}
                                                    >Inbound Price List</NavLink>
                                                }
                                            </Space>
                                        </Col>
                                    </Row>
                                </>
                                :
                                <>
                                    <Row align="middle" className={clsx(classes.bold, classes.bgwhite, classes.toggleRow)}>
                                        <Col xs={14} sm={12} md={12} lg={12} xl={12} xxl={12} className={classes.cursor}>
                                            <span onClick={() => handleMessages('all')}>  {
                                                previewMessages(type)
                                            }</span>
                                            {
                                                toggle && <div style={{ marginLeft: 15 }} className={clsx(classes.searchAnimation, classes.mobileDisplay, { [classes.iconAnimation]: iconAnimation })}>
                                                    <TextField autoComplete='one-time-code'
                                                        placeholder='Search Source and Message'
                                                        type='search'
                                                        fullWidth
                                                        id={idNamingConversion('Search', 'notification', 'TextField')}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                        className={classes.comInput}
                                                        variant={'standard'}
                                                        onFocus={() => setIconAnimation(true)}
                                                        onBlur={() => setIconAnimation(false)}
                                                    />
                                                    <Image
                                                        src={SearchIcon}
                                                        preview={false}
                                                    />
                                                </div>
                                            }
                                        </Col>
                                        <Col xs={10} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                            <Row className={clsx(classes.opacity, classes.mobileDisplay)}>
                                                {/* <Col className={clsx(classes.textAlignRight, classes.color)} span={6}></Col> */}
                                                {/* <Col className={clsx(classes.textAlignRight, classes.color)} span={6}>
                                                    <NavLink className={clsx(classes.color)} to={'#'} onClick={() => handleMessages('new')}>
                                                            New Messages {notificationDetails?.length > 0 ? notificationDetails?.filter((el) => { return el.is_seen === false }).length : 0}
                                                        </NavLink>
                                                </Col> */}
                                                <Col className={clsx(classes.textAlignRight, classes.color)} span={12}>
                                                    <NavLink id={idNamingConversion('Unread Messages', 'notification', 'Link')} className={clsx(classes.color)} to={'#'} onClick={() => handleMessages('unread')}>
                                                        Unread Messages {notificationDetails?.length > 0 ? notificationDetails?.filter((el) => { return el.is_seen === false })?.length : 0}
                                                    </NavLink>
                                                </Col>
                                                <Col className={clsx(classes.textAlignRight, classes.color)} span={12}>
                                                    <NavLink id={idNamingConversion('Starred Messages', 'notification', 'Link')} className={clsx(classes.color)} to={'#'} onClick={() => handleMessages('starred')}>
                                                        Starred Messages {notificationDetails?.length > 0 ? notificationDetails?.filter((el) => { return el.is_starred === true })?.length : 0}
                                                    </NavLink>
                                                </Col>
                                            </Row>
                                            {
                                                type !== 'starred' && <NavLink
                                                    to={`#`}
                                                    id={idNamingConversion('Select Multiple', 'notification', 'Link')}
                                                    onClick={() => setMultiples(!multiples)}
                                                    className={clsx(classes.notificationDelete, classes.customLink)}>
                                                    <Image
                                                        src={SelctMultiples}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Select Multiple</span>
                                                </NavLink>
                                            }
                                        </Col>
                                    </Row>
                                    <div className={clsx(classes.accordionBody, { [classes.accordionSelectList]: multiples && selected?.length > 0 })}>
                                        <ListTable
                                            search={search}
                                            loadTasks={() => dispatchFilter()}
                                            details={getList}
                                            loadMore={loadMore}
                                            loadMoreTask={() => loadMoreTask()}
                                            onDelete={(data) => onDelete(data)}
                                            onSelected={(value) => setSelected(value)}
                                            handleClick={(value) => handleRowClick(value)}
                                            selected={selected}
                                            type={type}
                                            onStarred={(data) => onStarred(data)}
                                            handleAccept={(data, type) => handleAccept(data, type)}
                                            handleReject={(data) => handleReject(data)}
                                            handleRejectClient={(data, type) => handleAccept(data, type)}
                                            handleRead={(data, type) => handleRead(data, type)}
                                            handleViewDocument={(data) => handleViewDocument(data)}
                                            loadMoreContent={loadMoreContent} onView={(data) => onView(data)} />
                                    </div>
                                    {
                                        multiples && (selected?.length > 0 &&
                                            <Row className={classes.notificationButtons}>
                                                <Col span={8} className={clsx(classes.textAlignLeft)}>
                                                    {
                                                        getList.length > 0 && selected.length === getList.length ? <><NavLink id={idNamingConversion('Delete All', 'notification', 'Link')} className={clsx(classes.deleteBtn)} to={'#'}
                                                            onClick={() => handleClearAll('all')}>
                                                            Delete All
                                                        </NavLink><div className=""> {`Selected Messages (${type === 'unread' ? `${notificationDetails?.length > 0 ? notificationDetails?.filter((el) => { return el.is_seen === false }).length : 0}` : `${notificationDetails?.length}`})`}</div></> : <><NavLink id={idNamingConversion('Delete', 'notification', 'Link')} className={clsx(classes.deleteBtn)} to={'#'} onClick={() => handleClearAll('ids')}>
                                                            Delete
                                                        </NavLink><div className=""> {`Selected Messages (${selected?.length})`}</div></>
                                                    }
                                                </Col>
                                                <Col span={8} className={clsx(classes.textAlignCenter)}>
                                                </Col>
                                                <Col span={8} className={clsx(classes.textAlignRight)}>
                                                    {/* {
                                                !multiples && <NavLink className={clsx(classes.AddMoreBtn)} to={'#'} onClick={() => setMultiples(!multiples)}>
                                                    Delete All
                                                </NavLink>
                                            } */}
                                                </Col>
                                            </Row>)
                                    }
                                </>
                        }
                    </div>
                    <div className={clsx(classes.textAlignCenter, classes.accDropDownButton)}>
                        <NavLink to={'#'} id={idNamingConversion('Toggle', 'notification', 'Link')} className={classes.disInline} onClick={(e) => { handleMessages('all'); handleClose() }}>
                            <Image
                                src={AccordionDropDownIcon}
                                preview={false}
                                className={classes.cursor}
                            />
                        </NavLink>
                    </div>
                </div>
                {/* </ClickAwayListener> */}
                <div className={clsx(classes.mainDashIcon, { [classes.toggleOpen]: toggle })}>
                    <div className={classes.dashRow}>
                        {
                            checkModulePermission('Sales', history) &&
                            <div className={clsx(classes.col_20)}>
                                <LottieAnimationHover href={'/sales'} title={"Sales"} icon={SalesIcon} ref={salesContainer} aRef={salesContainerAnim} />
                            </div>
                        }
                        {
                            checkModulePermission('Purchase', history) &&
                            <div className={clsx(classes.col_20)}>
                                <LottieAnimationHover href={'/purchase'} title={"Purchase"} icon={PurchaseIcon} ref={purchaseContainer} aRef={purchaseContainerAnim} />
                            </div>
                        }
                        {
                            checkModulePermission('Delivery', history) &&
                            <div className={clsx(classes.col_20)}>
                                <LottieAnimationHover href={'/delivery'} title={"Delivery"} icon={DeliveryIcon} ref={deliveryContainer} aRef={deliveryContainerAnim} />
                            </div>
                        }
                        {
                            checkModulePermission('Product', history) &&
                            <div className={clsx(classes.col_20)}>
                                <LottieAnimationHover href={'/product'} title={"Product"} icon={ProductIcon} ref={productContainer} aRef={productContainerAnim} />
                            </div>
                        }
                        {
                            checkModulePermission('Admin', history) &&
                            <div className={clsx(classes.col_20)}>
                                <LottieAnimationHover href={'/admin'} title={"Admin"} icon={AdminIcon} ref={adminContainer} aRef={adminContainerAnim} />
                            </div>
                        }
                    </div>
                </div>
            </div >
            <Modal
                title={'Delete Confirmation'}
                open={deleteAllModal}
                onOk={() => { setDeleteAllModal(false); setDeleteType(''); }}
                onCancel={() => { setDeleteAllModal(false); setDeleteType(''); }}
                width={525}
                className={clsx(classes.deletePopup, classes.deleteNotificationPopup)}
                // closeIcon={<CloseIcon />}
                footer={
                    [
                        <Button
                            key="yes"
                            type='submit'
                            color='primary'
                            variant="contained"
                            className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                            onClick={() => onDeleteAllPopup()}
                        >Yes</Button>,
                        <Button
                            key="no"
                            type='submit'
                            color='primary'
                            variant="contained"
                            className={clsx(classes.AddMoreBtn)}
                            onClick={() => setDeleteAllModal(false)}
                        >
                            No
                        </Button>,
                    ]}>
                <p>The selected message will be deleted permanently, Do you want to continue?</p>
                <p className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink')}><Image className={clsx(classes.disInline, classes.verticalAlignMiddle)} src={infoMarkIcon} preview={false} /> <span className={clsx(classes.disInline, classes.verticalAlignMiddle, classes.fonSize13)}>Starred Messages will not be deleted, un-check the "Starred" status; to Delete.</span></p>
            </Modal>
            <DeleteModal
                onClose={(v) => setDeleteModal(false)}
                id={datas?.id}
                loadTasks={() => {
                    loadTasks();
                    dispatchFilter(type)
                }}
                name={datas?.title}
                url={'notifications'}
                title={'Notifications'}
                visible={deleteModal} />
            {
                open && <>
                    {
                        component === 'supplier' ?
                            <PurchaseInvoiceModal open={open} format={readDetails?.billFormat}
                                handleClose={(o) => setOpen(o)}
                                title={`Purchase-Bill-${readDetails?.serialNo}`}
                                link={''} {...props}
                                details={readDetails} /> :
                            component === 'customer' ?
                                <InvoiceModal
                                    open={open}
                                    handleClose={(o) => setOpen(o)}
                                    title={`Sales-Bill-${readDetails?.serialNo}`}
                                    link={''} {...props}
                                    format={readDetails?.billFormat}
                                    details={readDetails} /> : component === 'salesQuote' ?
                                    <QuoteModal
                                        open={open}
                                        handleClose={(o) => setOpen(o)}
                                        title={`Sales-Quote-${readDetails?.serialNo}`}
                                        link={''} {...props}
                                        details={readDetails} /> : component === 'supplyQuote' ? <SupplyQuoteModal
                                            open={open}
                                            handleClose={(o) => setOpen(o)}
                                            title={`Supply-Quote-${readDetails?.serialNo}`}
                                            link={''} {...props}
                                            details={readDetails} /> : component === 'salesOrder' ? <OrderModal
                                                open={open}
                                                handleClose={(o) => setOpen(o)}
                                                title={`Sales-Order-${readDetails?.serialNo}`}
                                                link={''} {...props}
                                                details={readDetails} /> : component === 'purchaseOrder' ? <SupplyOrderModal
                                                    open={open}
                                                    handleClose={(o) => setOpen(o)}
                                                    title={`Supply-Order-${readDetails?.serialNo}`}
                                                    link={''} {...props}
                                                    details={readDetails} /> : ''
                    }
                </>
            }
            <Modal
                title={'Info Log Message'}
                width={460}
                open={visible}
                onOk={() => handleOk()}
                onCancel={() => handleOk()}
                // closeIcon={<CloseIcon />}
                footer={
                    [<Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, { [classes.loading]: editLoader }, { [classes.disabled]: reasonId === '' })}
                        onClick={() => handleAccept(datas, 'reject')}
                    >OK</Button>
                    ]}
                className={clsx(classes.commonPopup, classes.commonPopupText, classes.removeUnderline, classes.deletePopup)}>
                <Typography variant={'subtitle1'} className={clsx(classes.fonSize14, classes.textAlignLeft)} style={{ color: "#1c314c" }}>
                    You have chosen to reject, please mention your reason for rejection below</Typography>
                <AutoCompleteComponent
                    name={["Reason Codes ", <span key={'Catalogue Name'} className={classes.colorRedRequired}> *</span>]}
                    heads={[{ 'key': 'rejectReasonDesc', 'name': 'Description' }, { 'key': 'rejectReasonCode', 'name': 'Codes' }]}
                    details={rejectDetails}
                    parentValue={customObject(rejectDetails, reasonId)}
                    position={"bottom"}
                    customClasses={classes.margin20t}
                    onChange={(data) => setReasonId(data.id)}
                />
            </Modal>
        </React.Fragment>
    )
}

export default Home